export const environment = {
  production: false,
  HOST: "https://sigaqa.certicamara.com/"
  //HOST: "http://172.91.0.67:444"
};
